import { render, staticRenderFns } from "./PrimaryCallToAction.vue?vue&type=template&id=20e95614&scoped=true&"
import script from "./PrimaryCallToAction.vue?vue&type=script&lang=js&"
export * from "./PrimaryCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryCallToAction.vue?vue&type=style&index=0&id=20e95614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e95614",
  null
  
)

export default component.exports